import { Meal, MealTargetInput } from '../models/diary';

const round = (n: number) => Math.round(n * 10) / 10;

// The API returns meal-level `calories` (server-computed) but not per-macro totals.
// Each ingredient carries per-100g macros + `quantity` (grams), so totals are derived
// client-side: sum(quantity / 100 * value) across the meal's ingredients.
export const computeMealMacros = (meal: Meal): MealTargetInput => {
  const totals: MealTargetInput = { calories: 0, protein: 0, carbs: 0, fat: 0, fiber: 0, water: 0 };
  (meal.ingredients || []).forEach(ing => {
    const factor = (ing.quantity || 0) / 100;
    totals.calories += (ing.calories || 0) * factor;
    totals.protein += (ing.proteins || 0) * factor;
    totals.carbs += (ing.carbohydrates || 0) * factor;
    totals.fat += (ing.fats || 0) * factor;
    totals.fiber += (ing.fiber || 0) * factor;
    totals.water += (ing.water || 0) * factor;
  });
  return {
    calories: round(totals.calories),
    protein: round(totals.protein),
    carbs: round(totals.carbs),
    fat: round(totals.fat),
    fiber: round(totals.fiber),
    water: round(totals.water),
  };
};

// Sum the macro totals across several meals (used by the "Sumar desde comidas" button).
export const sumMealsMacros = (meals: Meal[]): MealTargetInput => {
  return (meals || []).reduce<MealTargetInput>((acc, meal) => {
    const m = computeMealMacros(meal);
    return {
      calories: round(acc.calories + m.calories),
      protein: round(acc.protein + m.protein),
      carbs: round(acc.carbs + m.carbs),
      fat: round(acc.fat + m.fat),
      fiber: round(acc.fiber + m.fiber),
      water: round(acc.water + m.water),
    };
  }, { calories: 0, protein: 0, carbs: 0, fat: 0, fiber: 0, water: 0 });
};
